import React, { useEffect, useRef } from "react";
import "./PageNotFound.scss";
import Image404 from "../../assets/images/404.jpeg"; 
import { gsap } from "gsap";

export const PageNotFound = () => {

  return (
    <div
      className="notfound-container"
      style={{ backgroundImage: `url(${Image404})` }}
    >
      <div className="overlay" />
      <div className="content">
        {/* <div className="error-badge">ERROR 404</div> */}
        <h1 className="title">
          <span className="line left-line" />
          PAGE NOT FOUND
          <span className="line right-line" />
        </h1>
        <p className="description">
          The page you were looking for could not be found. It might have been removed, renamed, or did not exist in the first place.
        </p>
        <button className="home-button" onClick={() => (window.location.href = "/")}>
          GO TO HOME PAGE
        </button>
      </div>
    </div>
  );
};
